import { forwardRef } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { ErrorLabel } from '../labels/error'
import Label from '../labels/label'
import { cn } from '../..'

interface PassedProps
  extends Omit<
      React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
      >,
      'size'
    >,
    VariantProps<typeof checkboxVariants> {
  brandKit?: boolean
  error?: string
  label: string
  classNames?: {
    label?: string
    parent?: string
  }
}

export const checkboxVariants = cva(
  [
    'mt-0 border-2 ring-2 ring-neutral-300 dark:ring-neutral-700 form-checkbox text-black bg-neutral-50 dark:bg-neutral-700 border-neutral-300 dark:border-neutral-600  rounded cursor-pointer',
  ],
  {
    variants: {
      size: {
        sm: 'w-4 h-4',
        base: 'w-5 h-5',
        lg: 'w-6 h-6',
        xl: 'w-8 h-8',
      },
      brandKit: {
        true: 'text-brand-or-black focus:ring-brand-or-black rounded-brand',
        false:
          'text-stampede-500 focus:ring-stampede-600 dark:checked:ring-stampede-500 outline-none',
      },
    },
    defaultVariants: {
      brandKit: false,
      size: 'base',
    },
  }
)

export const Checkbox = forwardRef<HTMLInputElement, PassedProps>(
  (
    { error, label = '', className, brandKit, size, classNames, ...rest },
    ref
  ) => {
    return (
      <div className="relative">
        <ErrorLabel error={error} />

        <div
          className={cn(
            'flex items-start  w-full py-1 px-1  cursor-pointer items-center',
            classNames?.parent ? classNames?.parent : undefined
          )}
        >
          <input
            className={cn(
              checkboxVariants({ brandKit, size }),
              'form-checkbox',
              className
            )}
            id={rest.id ?? rest.name}
            type="checkbox"
            {...rest}
            ref={ref}
          />
          {!!label ? (
            <Label
              className={cn(
                'w-full ml-3 font-medium text-sm cursor-pointer',
                classNames?.label ? classNames?.label : undefined
              )}
              htmlFor={rest.id ?? rest.name}
              dangerouslySetInnerHTML={{ __html: label }}
            />
          ) : null}
        </div>
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
